import React, { Component } from 'react';
import { connect } from 'react-redux'
import { store } from '../redux/store'
import { withTranslation } from "react-i18next";
import Fab from '@material-ui/core/Fab';
import AcademicRegTable from '../components/AcademicRegTable'
import { loadAcademicReg, gpaPredict } from '../redux/Actions/AcademicRegActions';
import Loader from './Loader'

class GpaPredict extends Component {
  componentDidMount() {    
    if (this.props.acad == null) {
      this.props.dispatch(loadAcademicReg())
    }
  }

  gpaCal() {    
    let acad = store.getState().AcademicRegReducers.acad     
    let std_id = localStorage.getItem('student_id')    
    let crs = '' 
    acad.forEach( value => {
       crs = crs + ','
           + '{' 
                 + '"sem":"' + value.sem + '",'
                 + '"yar":"' + value.yar + '",' 
                 + '"std_id":"' + std_id + '",'                  
                 + '"crs":"' + value.crs + '",' 
                 + '"lec":"' + value.lec + '",' 
                 + '"lab":"' + value.lab + '",' 
                 + '"crd":"' + value.crd + '",' 
                 + '"grd":"' + value.grd + '",' 
                 + '"ecrdc":"' + value.ecrdc + '",' 
                 + '"ccrdc":"' + value.ccrdc + '",' 
                 + '"ecrdcm":"' + value.ecrdcm + '",' 
                 + '"ipt":"' + value.ipt + '"' +
             '}'  
    });

    if (crs.length > 1) {
      crs = crs.substring(1, crs.length)
    }
    crs = '[' + crs + ']'    
    // this.props.dispatch(gpaPredict(crs))
    store.dispatch(gpaPredict(crs))
  }

  render() { 
    const { acad, gpa, isLoading, isRejected, isGpaPredict, t } = this.props

    if (isLoading) {   
      return <Loader />         
    }

    if (isRejected) {      
      return <div>Error 0</div>
    }

    return (            
      <>
        <p style={{marginLeft: '16px' }}><b>{t("Advance grade calculation")}</b></p>
        <AcademicRegTable acad={acad} gpa={gpa}/>
        <div style={{width: '51%', marginLeft: 'auto', marginRight: 'auto', marginBottom: '90px'}} >
          <Fab style = {{float: 'right' }} 
            color="secondary"               
            onClick={this.gpaCal}
            disabled={isGpaPredict}                
            >GPA
          </Fab>
        </div>
      </>  
    );
  }
}

function mapStateToProps(state) {  
  return {    
    acad: state.AcademicRegReducers.acad,
    gpa: state.AcademicRegReducers.gpa,
    isLoading: state.AcademicRegReducers.isLoading,
    isRejected: state.AcademicRegReducers.isRejected,
    isGpaPredict: state.AcademicRegReducers.isGpaPredict,
    err: state.AcademicRegReducers.err
  }
}

export default (withTranslation()(connect(mapStateToProps)(GpaPredict)))